module.exports = __webpack_public_path__ + "img/object_line.e6d9f126.png";